var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCommentMention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4004 3C14.8402 3.00009 15.217 3.15649 15.5303 3.46973C15.8435 3.78297 15.9999 4.15978 16 4.59961V19L12.7998 15.7998H1.59961C1.15978 15.7997 0.782967 15.6433 0.469727 15.3301C0.156505 15.0168 4.64108e-05 14.6401 0 14.2002V4.59961C9.26921e-05 4.15978 0.156486 3.78297 0.469727 3.46973C0.782967 3.15649 1.15978 3.00009 1.59961 3H14.4004ZM1.59961 14.2002H13.4805L14.4004 15.0996V4.59961H1.59961V14.2002ZM12.7998 12.5996H3.2002V11H12.7998V12.5996ZM12.7998 10.2002H3.2002V8.59961H12.7998V10.2002ZM12.7998 7.7998H3.2002V6.2002H12.7998V7.7998Z",
    fill: "#4C5E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C17.2091 0 19 1.79086 19 4C19 6.20914 17.2091 8 15 8C12.7909 8 11 6.20914 11 4C11 1.79086 12.7909 0 15 0Z",
    fill: "#F51D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCommentMention);
export default __webpack_public_path__ + "static/media/icons_comment_mention.8f7d7f74.svg";
export { ForwardRef as ReactComponent };